import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { TextArea } from "@progress/kendo-react-inputs";
import { Label, Error, Hint } from "@progress/kendo-react-labels";

export default function FormTextArea(fieldRenderProps: FieldRenderProps) {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        type,
        optional,
        ...others
    } = fieldRenderProps;
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hindId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    return (
        <FieldWrapper>
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label}
            </Label>
            <div className={"k-form-field-wrap"}>
                <TextArea
                    valid={valid}
                    id={id}
                    disabled={disabled}
                    rows={4}
                    ariaDescribedBy={`${hindId} ${errorId}`}
                    {...others}
                />
                {showHint && <Hint id={hindId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
        </FieldWrapper>
    );
};